import React from "react";

// this component include label, input text box
// required *, help/tip message, and error state with error message

// base on input props.isRequired, props.hasError
// update the className, to show error, and required

// use props.value to set text
// use on chagne props.getTextString return new value to parent

const InputTxt = (props) => {
  // default onChange handler
  function defaultOnChange(e) {
    // onChange is return value to formik
    if (props.onChange !== undefined && props.onChange !== null) {
      props.onChange(e);
    } else {

    }

    // getTextString is return value to text update change handler
    if (props.getTextString !== undefined && props.getTextString !== null) {
      props.getTextString(e.target.value);
    } else {

    }
  }
  function defaultOnBlur(e) {

    // onChange is return value to formik
    if (props.onBlur !== undefined && props.onBlur !== null) {
      props.onBlur(e);
    } else {

    }

    // getTextString is return value to text update change handler
    if (props.getTextString !== undefined && props.getTextString !== null) {
      props.getTextString(e.target.value);
    } else {
;
    }
  }

  return (
    <div className="inputbox">
      {/* display label */}
      <label
        className={`inputbox__label ${
          props.hasError ? "inputbox__label--error" : ""
        }
        ${props.isDisabled ? "inputbox__label--disabled" : ""}
        `}
      >
        {props.labelText}
        {/* display reqiored * */}
        <span
          className="inputbox__required"
          style={props.isRequired ? {} : { display: "none" }}
        >
          *
        </span>
        {/* text input box */}
        <input
          id={props.id}
          type={props.type}
          required={props.isRequired ? true : false}
          placeholder={props.placeholder}
          className={`inputbox__textbox ${
            props.hasError ? "inputbox__textbox--error" : ""
          }`}
          value={props.value}
          onChange={(e) => defaultOnChange(e)}
          onBlur={(e) => defaultOnBlur(e)}
          disabled={props.isDisabled ? true : false}
        />
        {/* display help message */}
        <span className="inputbox__help">{props.helpMessage}</span>
        {/* display errorMessage or formik error message */}
        <span
          className="inputbox__error"
          style={props.hasError ? {} : { display: "none" }}
        >
          {props.errorMessage}
        </span>
      </label>
    </div>
  );
};

export default InputTxt;
